import { stableSort, getSorting } from '../../../Functions';
export function TallySheetHeaderCompose(page, rowL, ts, dataUrl) {
    var doc = ts;
    var _y = rowL;
    var _space = page.spacingunit;

    var imageX = 140;
    doc.addImage(dataUrl, 'JPEG', imageX, page.headerFromTop, 55, 25);
    _y += _space * 4;
    doc.text(136, _y, '"Your Alternative Shipping..."');
    _y += _space * 2;

    doc.setFont("times", "bold");
    doc.text('OCEAN TRANSPORT GROUP OF COMPANIES INC.', 110, _y, null, null, 'center');
    doc.setFont("times", "normal");

    return _y;
}

export function TallySheetBodyCompose(page, rowL, ts, header, forTime) {
    var doc = ts;
    var _y = rowL;
    var _space = page.spacingunit;

    let current_datetime = new Date()
    let formatted_date = (current_datetime.getMonth() + 1) + "/" + current_datetime.getDate() + "/" + current_datetime.getFullYear();

    _y += _space;
    var tallySheetType = header.tallySheetType ? header.tallySheetType : '';
    doc.text(tallySheetType.toUpperCase() + ' TALLY SHEET', 110, _y, null, null, 'center');

    _y += _space * 2;
    doc.text(20, _y, 'Date: ' + formatted_date);

    _y += _space * 2;
    var checkBox = new doc.AcroForm.CheckBox();
    checkBox.fieldName = "CheckBoxStatus";
    checkBox.readOnly = true;
    if (tallySheetType === "Loading" || tallySheetType === "loading") {
        checkBox.Rect = [20.5, _y - (_space * 0.75), 5, 5.5];
    }
    else if (tallySheetType === "Unloading" || tallySheetType === "unloading") {
        checkBox.Rect = [50.5, _y - (_space * 0.75), 5, 5.5];
    }
    doc.addField(checkBox);

    doc.rect(20, _y - (_space * 0.8), 6, 6);
    doc.text(30, _y, "Loading");

    doc.rect(50, _y - (_space * 0.8), 6, 6);
    doc.text(60, _y, "Unloading");

    _y += _space * 2;
    doc.text(20, _y, 'Time Started:');
    let timeStarted = forTime.timeStarted ? new Date(forTime.timeStarted) : new Date()
    let formatted_timeStarted = (timeStarted.getMonth() + 1) + "/" + timeStarted.getDate() + "/" + timeStarted.getFullYear() + " " + timeStarted.getHours() + ":" + timeStarted.getMinutes() + ":" + timeStarted.getSeconds()
    doc.text(70, _y, formatted_timeStarted);
    doc.line(70, _y + 1, 190, _y + 1);
    _y += _space;
    doc.text(20, _y, 'Time Ended:');
    let timeFinished = forTime.timeFinished ? new Date(forTime.timeFinished) : new Date()
    let formatted_timeFinished = (timeFinished.getMonth() + 1) + "/" + timeFinished.getDate() + "/" + timeFinished.getFullYear() + " " + timeFinished.getHours() + ":" + timeFinished.getMinutes() + ":" + timeFinished.getSeconds()
    doc.text(70, _y, formatted_timeFinished);
    doc.line(70, _y + 1, 190, _y + 1);

    _y += _space * 2;
    doc.text(20, _y, 'Vessel:');
    doc.text(70, _y, header.vessel ? header.vessel : '');
    doc.line(70, _y + 1, 190, _y + 1);
    // if (header) {
    //     _y += _space;
    //     doc.text(20, _y, 'Actual Vessel:');
    //     doc.text(70, _y, header.vessel ? header.vessel : '');
    //     doc.line(70, _y + 1, 190, _y + 1);
    // }
    _y += _space;
    doc.text(20, _y, 'Voyage No.:');
    doc.text(70, _y, header.voyageNum ? header.voyageNum : '');
    doc.line(70, _y + 1, 190, _y + 1);

    _y += _space;
    doc.text(20, _y, 'Voyage Ref.:');
    doc.text(70, _y, header.remarks ? header.remarks : '');
    doc.line(70, _y + 1, 190, _y + 1);

    var route = header.route ? header.route.split(" - ") : "";

    _y += _space * 2;
    doc.text(20, _y, 'Port of Origin:');
    doc.text(70, _y, header.branchOrigin ? header.branchOrigin : header.originBranch ? header.originBranch : route && route.length > 0? route[0] : '');
    doc.line(70, _y + 1, 190, _y + 1);
    _y += _space;
    doc.text(20, _y, 'Port of Destination:');
    doc.text(70, _y, header.branchDestination ? header.branchDestination : header.destinationBranch ? header.destinationBranch : route && route.length > 1 ? route[1] : '');
    doc.line(70, _y + 1, 190, _y + 1);

    _y += _space;

    return _y;
}

export function TallySheetRemarkCompose(page, rowL, ts, data) {
    var doc = ts;
    var _y = rowL;
    var _space = page.spacingunit;
    // console.log('data', data);
    _y += _space;
    doc.text(20, _y, 'Remarks:');
    _y += _space;
    if (data && data.remarks) {
        var splitRemark = doc.splitTextToSize(data.remarks, 170);
        doc.text(20, _y, splitRemark);
        for (let index = 0; index < splitRemark.length; index++) {
            doc.line(20, _y + 1, 190, _y + 1);
            _y += (_space * 0.8);
        }
    }
    else {
        doc.line(20, _y + 1, 190, _y + 1);
        _y += (_space * 0.8);
    }

    return _y;
}

export function TallySheetTableCompose(page, rowL, ts, data, header) {
    var doc = ts;
    var _y = rowL;
    var _space = page.spacingunit;

    var newPage = false;
    var tallySheetType = header.tallySheetType ? header.tallySheetType : '';

    _y += _space;

    if (tallySheetType === "Unloading" || tallySheetType === "unloading") {
        doc.text(20, _y, 'No.');
        doc.text(35, _y, 'Container #');
        doc.text(70, _y, 'MT/FULL');
        doc.text(90, _y, 'Plate No.');
        doc.text(115, _y, 'Driver Name');
        doc.text(160, _y, 'CY GROUNDED');
    } else {
        doc.text(20, _y, 'No.');
        doc.text(35, _y, 'Container #');
        doc.text(75, _y, 'MT/FULL');
        doc.text(100, _y, 'Plate No.');
        doc.text(135, _y, 'Driver Name');
    }
    doc.line(20, _y + 1, 190, _y + 1);
    _y += _space;
    
    let NewData = stableSort(data, getSorting('asc', 'containerVanNum'));
    for (let i = 0; i < NewData.length; i++) {
        if (tallySheetType === "Unloading" || tallySheetType === "unloading") {
            doc.text(20, _y, (i + 1).toString());
            doc.text(35, _y, NewData[i].containerVanNum ? NewData[i].containerVanNum : '');
            doc.text(70, _y, NewData[i].containerType ? NewData[i].containerType === 'FL' ? 'FULL' : 'MT' : '');
            doc.text(90, _y, NewData[i].plateNum ? NewData[i].plateNum : '');
            doc.text(115, _y, NewData[i].driver ? NewData[i].driver : '');
            doc.text(160, _y, NewData[i].cyPullOutName ? NewData[i].cyPullOutName : '');
        } else {
            doc.text(20, _y, (i + 1).toString());
            doc.text(35, _y, NewData[i].containerVanNum ? NewData[i].containerVanNum : '');
            doc.text(75, _y, NewData[i].containerType ? NewData[i].containerType === 'FL' ? 'FULL' : 'MT' : '');
            doc.text(100, _y, NewData[i].plateNum ? NewData[i].plateNum : '');
            doc.text(135, _y, NewData[i].driver ? NewData[i].driver : '');
        }
        doc.line(20, _y + 1, 190, _y + 1);
        _y += _space;

        // console.log(_y)
        if (_y >= 280) {
            doc.addPage(page.layoutL, page.papersize.unit, page.papersize.format);
            _y = 10;
            _y += _space * 2;
            newPage = true;

            if (newPage) {
                if (tallySheetType === "Unloading" || tallySheetType === "unloading") {
                    doc.text(20, _y, 'No.');
                    doc.text(35, _y, 'Container #');
                    doc.text(70, _y, 'MT/FULL');
                    doc.text(90, _y, 'Plate No.');
                    doc.text(115, _y, 'Driver Name');
                    doc.text(160, _y, 'CY GROUNDED');
                } else {
                    doc.text(20, _y, 'No.');
                    doc.text(35, _y, 'Container #');
                    doc.text(75, _y, 'MT/FULL');
                    doc.text(100, _y, 'Plate No.');
                    doc.text(135, _y, 'Driver Name');
                }
                doc.line(20, _y + 1, 190, _y + 1);
                _y += _space;
            }
        }
        else {
            newPage = false;
        }
    }
}